import controller from './product-detail.controller';
import template from './product-detail.view.html';

let ProductDetailComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ProductDetailComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/product-detail/product-detail.component.js
 **/